<input
    type="checkbox"
    class="m-1 {{ gtmClass }}"
    [ngClass]="{ 'cursor-pointer': !disabled, checked: isChecked }"
    [disabled]="disabled"
    [attr.id]="id"
    [checked]="isChecked"
    (click)="isClicked(value)"
/>
<label [ngClass]="{ 'cursor-pointer': !disabled }" [attr.for]="id">{{ label }}</label>
